import config from '../config';

export const pageview = (url: string) => {
  // Route changes tracking with url
  gtag('config', config.GOOGLE_ANALYTICS_KEY || '', { page_path: url });
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const googleAnalyticsEvent = (eventName: string, event: object) => {
  // Send custom event to Google Analytics
  // This function used in CIBC
  gtag('event', eventName, event);
};

export const googleAnalyticsDimension = (dimensionName: string, dimensionValue: string | number) => {
  // Sends the custom dimension to Google Analytics.
  // unsused now
  gtag('set', { dimensionName: dimensionValue });
};
